export const fmt = (sec) => {
  if (sec == null || isNaN(sec)) return "0:00";
  const s = Math.floor(sec % 60);
  const m = Math.floor(sec / 60) % 60;
  const h = Math.floor(sec / 3600);
  const mm = h > 0 ? String(m).padStart(2, "0") : String(m);
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
};

export const scoreColor = (score) => {
  if (score >= 85) return "bg-accent text-accent-foreground";
  if (score >= 70) return "bg-primary text-primary-foreground";
  return "bg-secondary text-muted-foreground";
};
